import { render, staticRenderFns } from "./IssueEditor.vue?vue&type=template&id=0567742f"
import script from "./IssueEditor.vue?vue&type=script&lang=js"
export * from "./IssueEditor.vue?vue&type=script&lang=js"
import style0 from "./IssueEditor.vue?vue&type=style&index=0&id=0567742f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports